export default "__VITE_ASSET__DsuwEDyd__"